import Vue from 'vue'
// 配置页面路由
import Router from 'vue-router'
// 导入刚才编写的组件
import AppIndex from '@/components/home/AppIndex'
import Login from '@/components/Login'
import Home from '@/components/Home'
import BussinessIndex from '@/components/bussiness/BussinessIndex'
import AboutIndex from '@/components/about/AboutIndex'
import JoinIndex from '@/components/join/JoinIndex'


// import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)

export default new Router({
    // 将默认路由配置的hash模式切换为history模式
  mode: 'history',
  routes: [

    // {
    //   path: '/',
    //   name: 'AppIndex',
    //   redirect: '/index'
    // },
    // 下面都是固定的写法
    {
      // 注意这里并没有把首页访问的路径设置为/home/index，所以仍然可以通过/index访问首页
      // 这里配置其实是感受不到/home这个路径存在的，之后再添加新的页面，可以直接在children中增添对应的内容
      path: '/',
      name: 'AppIndex',
      component: AppIndex,
      // home页面不需要被访问
      // redirect: '/home/',
      // children: [
      //   {
      //     path: '/index',
      //     name: 'AppIndex',
      //     component: AppIndex
      //   },

      //   {
      //     path: '/about',
      //     name: 'About',
      //     component: AboutIndex
      //   },

      //   {
      //     path: '/bussiness',
      //     name: 'Bussiness',
      //     component: BussinessIndex
      //   },

      //   {
      //     path: '/join',
      //     name: 'Join',
      //     component: JoinIndex
      //   }
      // ]
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js